<div class="popup-model popup-min shadow top">
  <div class="d-flex justify-content-between align-items-center pink-header P-2">
    <h5 class="flex-grow-1 text-center mt-1">Modify KPI</h5>
    <div data-svg-wrapper style="position: relative" class="p-1">
      <button class="btn p-0 d-flex align-items-center" (click)="onClose()">
        <img src="assets/icon/close.svg" />
      </button>
    </div>
  </div>
  <form [formGroup]="configForm()" class="p-4 scrollable-container">

    <div class="row">
      <div class="col-md-6 mb-1 text-center">
        <label for="type" class="form-label text-muted">{{'CONFIGURATION_DONNEES.TYPE' | translate}}</label>
        <input type="text" class="form-control input-field" id="type" formControlName="type" [disabled]="true">
      </div>
      <div class="col-md-6 mb-1 text-center">
        <label for="name" class="form-label text-muted">{{'GLOBAL.NOM' |translate}}</label>
        <input type="text" class="form-control input-field" id="name" formControlName="name" [disabled]="true">
      </div>
    </div>
    @if (typeSaisieKpi() == 'InputText' || !configView()) {
      <div>
        @if (configView()) {
          <div class="row">
            <div class="col-md-6 mb-1 text-center">
              <label for="unit" class="form-label d-block text-muted">{{'CONFIGURATION_DONNEES.UNITE' | translate}}</label>
              <ng-select
                [items]="availableUnits()"
                bindLabel="displayName"
                bindValue="formattedValue"
                formControlName="unit"
                [searchable]="true"
                [clearable]="false"
                placeholder="Select unit"
                class="custom-ng-select">
                <ng-template ng-option-tmp let-item="item">
                  {{item.displayName}}
                </ng-template>
              </ng-select>
            </div>
            <div class="col-md-6 mb-1 text-center">
              <label for="targetValue" class="form-label">{{'CONFIGURATION_DONNEES.TARGET_VALUE' | translate}}</label>
              <input type="text" class="form-control input-field" id="targetValue" formControlName="targetValue">
            </div>
          </div>
        }
        @if (!configView()) {
          <div class="row">
            <div class="col-md-12 mb-1 text-center">
              <label for="targetValue" class="form-label text-muted">{{'CONFIGURATION_DONNEES.TARGET_VALUE' | translate}}
              Site</label>
              <input type="text" class="form-control input-field" id="targetValue" formControlName="targetValueSite"
                [disabled]="true">
              </div>
              <div class="col-md-12 mb-1 text-center">
                <label for="targetValue" class="form-label"
                  [ngClass]="{ 'text-muted': !autorisePourUtil() }">{{'CONFIGURATION_DONNEES.TARGET_VALUE' | translate}}
                Blast</label>
                <input type="text" class="form-control input-field" id="targetValue" formControlName="targetValueBlast">
                <div class="d-flex align-items-center p-2">
                  <button class="btn p-0 d-flex align-items-center" (click)="resetTargetValueBlast()"
                    [disabled]="!autorisePourUtil()">
                    <img src="assets/icon/restore.png" class="me-2" alt="Restore Icon" />
                    <span>Reset</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12 mb-1 text-center">
                <label for="targetValue" class="form-label text-muted">{{'CONFIGURATION_DONNEES.DESIGN' | translate}}</label>
                <input type="text" class="form-control input-field" id="targetValue" formControlName="targetValueDesign">
              </div>
              <div class="col-md-12 mb-1 text-center">
                <label for="targetValue" class="form-label text-muted">{{'CONFIGURATION_DONNEES.MEASURED' | translate}}
                </label>
                <input type="text" class="form-control input-field" id="targetValue" formControlName="targetValueMeasured">
              </div>
              <div class="col-md-12 mb-1 text-center">
                <label for="targetValue" class="form-label"
                [ngClass]="{ 'text-muted': !autorisePourUtil() }">{{'CONFIGURATION_DONNEES.MANUEL' | translate}}</label>
                <input type="text" class="form-control input-field" id="targetValue" formControlName="targetValueManual">
                <div class="d-flex align-items-center p-2">
                  <button class="btn p-0 d-flex align-items-center" (click)="resetManualValue()"
                    [disabled]="!autorisePourUtil()">
                    <img src="assets/icon/restore.png" class="me-2" alt="Restore Icon" />
                    <span>Reset</span>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      }
      @if (configView()) {
        <div>
          <div>
            @if (typeSaisieKpi() == 'InputText' || !configView()) {
              <div class="row">
                <div class="col-md-6 mb-1 text-center">
                  <label for="minValue" class="form-label">{{'CONFIGURATION_DONNEES.VALEUR_MIN' | translate}}</label>
                  <input type="text" class="form-control input-field" id="minValue" formControlName="minValue">
                </div>
                <div class="col-md-6 mb-1 text-center">
                  <label for="maxValue" class="form-label">{{'CONFIGURATION_DONNEES.VALEUR_MAX' | translate}}</label>
                  <input type="text" class="form-control input-field" id="maxValue" formControlName="maxValue">
                </div>
              </div>
            }
            <div class="row">
              @if (typeSaisieKpi() == 'YesOrNo' || typeSaisieKpi() == 'InputText' ||!configView()) {
                <div class="col-md-6 mb-1 text-center">
                  <label for="calculeMode"
                  class="form-label text-center">{{'CONFIGURATION_DONNEES.CALCUL_MODE' | translate}}</label>
                  <select class="form-control input-field" id="calculeMode" formControlName="calculeMode">
                    @for (item of tabModeSaisieProjet(); track item) {
                      <option [ngValue]="item.val">{{item.nom}}</option>
                    }
                  </select>
                </div>
              }
              @if (typeSaisieKpi() == 'InputText' ||!configView()) {
                <div class="col-md-6 mb-1 text-center">
                  <label for="access" class="form-label">{{'CONFIGURATION_DONNEES.ACCESS' | translate}}</label>
                  <select class="form-control input-field" id="access" formControlName="access">
                    <option value="0">Hidden</option>
                    <option value="1">Read</option>
                    <option value="2">Read-Write</option>
                  </select>
                </div>
              }
            </div>
          </div>
          <div class="mb-2 mt-2">
            <div class="d-flex align-items-center justify-content-start">
              <div class="switch  custom-margin-left">
                <input id="activate" type="checkbox" formControlName="activate" />
                <label for="activate"></label>
              </div>
              <span class="switch-label">
                {{'CONFIGURATION_DONNEES.ACTIVE' | translate}}
              </span>
            </div>
          </div>
        </div>
      }

      <div class="d-flex justify-content-center pt-3" style="gap: 20px;">
        <button type="button" class="btn btn-outline-primary"
        (click)="onClose()">{{'GLOBAL.ANNULER' | translate}}</button>
        <button type="submit" class="btn primary-button" (click)="onSubmit()"
        [disabled]="!autorisePourUtil()">{{'GLOBAL.CONFIRMER' | translate}}</button>
      </div>
    </form>
  </div>